import AlleventsScreen from './containers/alleventsScreen'

export {default as AlleventsScreenLayout} from './components/alleventsScreenLayout'

export default AlleventsScreen
